import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { Constants } from 'app/shared/shared-constants';
import { akvToModel, akvToResource } from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { AzureCosmosDbMongoDbApiLinkedService } from 'app/model/linkedservice/azure-cosmos-db-mongodb-api.linkedservice';
import { connectionStringPartToModel } from 'app/shared/utils/linkedservice-parameter.util';
import { ITridentResource } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureCosmosDbMongoDbApiLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                account: '*',
                connectionString: 'secret',
                database: '*',
                encryptedCredential: '*',
                isServerVersionAbove32: '*'
            }
        }
    }
})
export class AzureCosmosMongoDbApiLinkedServiceAdapter extends LinkedServiceAdapter<AzureCosmosDbMongoDbApiLinkedService> {
    protected modelConstructor(): new () => AzureCosmosDbMongoDbApiLinkedService {
        return AzureCosmosDbMongoDbApiLinkedService;
    }

    protected model(): IModel {
        return AzureCosmosDbMongoDbApiLinkedService.MODEL;
    }

    protected override toAzureTypeProperties = (tridentResource: ITridentResource): Partial<Model.CosmosDbMongoDbApiLinkedServiceTypeProperties> => {
        try {
            const connectionDetails = JSON.parse(tridentResource.connectionDetails);
            const extensionDataSourcePath = JSON.parse(connectionDetails.extensionDataSourcePath);
            return {
                connectionString: extensionDataSourcePath.server,
                isServerVersionAbove32: extensionDataSourcePath.serverVersion === 'Above 3.2'
            }
        } catch (e) {
            return {};
        }
    };

    protected async propertiesToResourceAsync(linkedService: AzureCosmosDbMongoDbApiLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.CosmosDbMongoDbApiLinkedService;
        properties.type = Metamodel.modelFor(AzureCosmosDbMongoDbApiLinkedService).name;
        if (!linkedService.enableAKV) {
            if (linkedService != null) {
                properties.typeProperties = {
                    connectionString: this._connectionStringToResource(linkedService.connectionString),
                    account: this._connectionStringToResource(linkedService.account),
                    database: linkedService.databaseName,
                    isServerVersionAbove32: linkedService.isServerVersionAbove32
                };
            }
        } else {
            if (linkedService != null) {
                properties.typeProperties = {
                    connectionString: akvToResource(linkedService.referedAKV, this.context),
                    database: linkedService.databaseName,
                    isServerVersionAbove32: linkedService.isServerVersionAbove32
                };
            }
        }
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: AzureCosmosDbMongoDbApiLinkedService): Promise<AzureCosmosDbMongoDbApiLinkedService> {
        const properties = linkedServiceResource.properties as Model.CosmosDbMongoDbApiLinkedService;

        linkedService.connectionString = undefined;
        linkedService.databaseName = undefined;
        linkedService.enableAKV = false;
        linkedService.referedAKV = undefined;

        if (properties.typeProperties.connectionString
            && (properties.typeProperties.connectionString as Model.SecretBase).type === 'AzureKeyVaultSecret') {
            linkedService.referedAKV = akvToModel(properties.typeProperties.connectionString as Model.AzureKeyVaultSecretReference, this.context);
            linkedService.enableAKV = true;
        } else if (properties.typeProperties.connectionString != null) {
            linkedService.connectionString = Constants.maskedCredential;
            connectionStringPartToModel(linkedService, AzureCosmosDbMongoDbApiLinkedService.ACCOUNT, properties.typeProperties.account);
        }
        linkedService.databaseName = properties.typeProperties.database;
        linkedService.isServerVersionAbove32 = properties.typeProperties.isServerVersionAbove32;

        return linkedService;
    }
}
